/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Builds_CompressedInputs */

const id_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% terkompresi)`)
};

const ms_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% dimampatkan)`)
};

const da_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% komprimeret)`)
};

const de_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% komprimiert)`)
};

const en_us2_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% compressed)`)
};

const es_es2_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% comprimido)`)
};

const es_mx2_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% comprimido)`)
};

const fil_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% compressed)`)
};

const fr_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% compressé)`)
};

const it_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% compresso)`)
};

const hu_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% tömörítve)`)
};

const nl_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% gecomprimeerd)`)
};

const no_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% komprimert)`)
};

const pl_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% skompresowane)`)
};

const pt_br2_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% compactado)`)
};

const pt_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% comprimido)`)
};

const ro_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% comprimat)`)
};

const fi_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% pakattu)`)
};

const sv_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% komprimerat)`)
};

const vi_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(nén ${i?.percent}%)`)
};

const tr_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(%${i?.percent} sıkıştırılmış)`)
};

const cs_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% komprimováno)`)
};

const bg_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% компресирано)`)
};

const ru_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(сжато ${i?.percent}%)`)
};

const uk_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% стиснення)`)
};

const ar_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% مضغوط)`)
};

const hi_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% संपीड़ित)`)
};

const th_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(บีบอัด ${i?.percent}%)`)
};

const ja_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% 圧縮)`)
};

const zh_cn2_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% 已压缩)`)
};

const zh_hant1_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% 已壓縮)`)
};

const ko_builds_compressed = /** @type {(inputs: Builds_CompressedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.percent}% 압축)`)
};

/**
* | output |
* | --- |
* | "({percent}% compressed)" |
*
* @param {Builds_CompressedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_compressed = /** @type {((inputs: Builds_CompressedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_CompressedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_compressed(inputs)
	if (locale === "ms") return ms_builds_compressed(inputs)
	if (locale === "da") return da_builds_compressed(inputs)
	if (locale === "de") return de_builds_compressed(inputs)
	if (locale === "en-US") return en_us2_builds_compressed(inputs)
	if (locale === "es-ES") return es_es2_builds_compressed(inputs)
	if (locale === "es-MX") return es_mx2_builds_compressed(inputs)
	if (locale === "fil") return fil_builds_compressed(inputs)
	if (locale === "fr") return fr_builds_compressed(inputs)
	if (locale === "it") return it_builds_compressed(inputs)
	if (locale === "hu") return hu_builds_compressed(inputs)
	if (locale === "nl") return nl_builds_compressed(inputs)
	if (locale === "no") return no_builds_compressed(inputs)
	if (locale === "pl") return pl_builds_compressed(inputs)
	if (locale === "pt-BR") return pt_br2_builds_compressed(inputs)
	if (locale === "pt") return pt_builds_compressed(inputs)
	if (locale === "ro") return ro_builds_compressed(inputs)
	if (locale === "fi") return fi_builds_compressed(inputs)
	if (locale === "sv") return sv_builds_compressed(inputs)
	if (locale === "vi") return vi_builds_compressed(inputs)
	if (locale === "tr") return tr_builds_compressed(inputs)
	if (locale === "cs") return cs_builds_compressed(inputs)
	if (locale === "bg") return bg_builds_compressed(inputs)
	if (locale === "ru") return ru_builds_compressed(inputs)
	if (locale === "uk") return uk_builds_compressed(inputs)
	if (locale === "ar") return ar_builds_compressed(inputs)
	if (locale === "hi") return hi_builds_compressed(inputs)
	if (locale === "th") return th_builds_compressed(inputs)
	if (locale === "ja") return ja_builds_compressed(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_compressed(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_compressed(inputs)
	return ko_builds_compressed(inputs)
});
export { builds_compressed as "builds.compressed" }